import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MyTrainingList" })
export default class MyTrainingList extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public courses: any[] = [];
    public filterMode: string = null;

    get routes() {
        return (<any>window).App.routes;
    }

    public async mounted() {
        this.setFilter("AllCourses");
        this.filterMode = "AllCourses";

        const urlParams = new URLSearchParams(window.location.search);
        let activationCode = urlParams.get('activationcode');

        if (activationCode) {
            this.searchSecretCourses();
            this.$store.commit("myTrainingStore/setActivationSecretCourseCode", activationCode);
        }
    }

    public async setFilter(mode: string) {
        switch (mode) {
            case "AllCourses":
                await this.getAllCoursesData();
                this.filterMode = "AllCourses";
                break;
            case "MyCourses":
                await this.getMyCoursesData();
                this.filterMode = "MyCourses";
                break;
            case "MyCompletedCourses":
                await this.getMyCompletedCoursesData();
                this.filterMode = "MyCompletedCourses";
                break;
            case "SecretCourses":
                this.searchSecretCourses();
                break;
        }
    }

    public async getAllCoursesData() {
        this.isLoading = true;
        this.courses = (await Axios.post(this.routes.MyBremboPartsTraining_GetCourses, null)).data;
        this.isLoading = false;
    }

    public async getMyCoursesData() {
        this.isLoading = true;
        this.courses = (await Axios.post(this.routes.MyBremboPartsTraining_GetRegisteredCourses, { excludeTrainingRegistrationStatus: "Completed" })).data;
        this.isLoading = false;
    }

    public async getMyCompletedCoursesData() {
        this.isLoading = true;
        this.courses = (await Axios.post(this.routes.MyBremboPartsTraining_GetRegisteredCourses, { trainingRegistrationStatus: "Completed" })).data;
        this.isLoading = false;
    }

    public searchSecretCourses() {
        this.$store.commit("myTrainingStore/setSecretCourseSubscribeVisible", true);
    }

    public formatDate(dateItem: string): string {
        if (dateItem == null) {
            return "";
        }

        let date = new Date(dateItem);
        return date.toLocaleString((<any>window).App.culture, {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit"
        });
    }
};